import { BillingCycle } from '@api/api/subscription-schema';

export enum PlanCardType {
  Basic = 'basic',
  Pro = 'pro',
}

export enum ChangingPlanTier {
  Upgrading = 'upgrading',
  DownGrading = 'downGrading',
  Same = 'same',
  Initial = 'initial',
}

// TODO move this to useSubscription store after pro to default goal, replacing the Plan interface
export interface SubscribingPlan {
  type: PlanCardType;
  tier: ChangingPlanTier;
  billingCycle: BillingCycle;
}
